import { useState } from "react";
import PromptInput from "../../components/common/ui/PromptInput";
import BlankState from "../../components/common/ui/BlankData";
import GradientDetailLayout from "../../components/common/ui/GradientLayout";


const JobDescription = ({ jobData, generatedContent, handleGenerateContent , handleSaveContent,isGenerating , isSaving , inputContent , setInputContent,setIsGenerating,setIsSaving}) => {

    // Debug logging
    console.log('JobDescription received generatedContent:', generatedContent);
    console.log('JobDescription received jobData:', jobData);

    const renderJobDescription = () => {
        if (!jobData.jobDescription && !generatedContent)
      return <BlankState title="Job Description" />;
    return (
      <div className="space-y-6 h-full pl-6">
        {(jobData?.jobDescription || generatedContent) && (
          <>
          <div className="w-full flex flex-col justify-between h-full min-h-[calc(100vh-220px)]">
            <div>
              <div>
                <h2 className="text-lg font-semibold mb-3">Overview:</h2>
                <p className="text-gray-600">
                  {typeof generatedContent?.overview === 'string' ? generatedContent.overview :
                   typeof jobData?.jobDescription?.overview === 'string' ? jobData.jobDescription.overview :
                   'No overview available'}
                </p>
              </div>

              <div className="mt-6">
                <h2 className="text-lg font-semibold mb-3">
                  Key Responsibilities:
                </h2>
                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                  {Array.isArray(generatedContent?.responsibilities) ? 
                    generatedContent.responsibilities.map((item, index) => (
                      <li key={index}>{typeof item === 'string' ? item : JSON.stringify(item)}</li>
                    )) :
                   Array.isArray(jobData?.jobDescription?.generatedResponsibilities) ?
                    jobData.jobDescription.generatedResponsibilities.map((item, index) => (
                      <li key={index}>{typeof item === 'string' ? item : JSON.stringify(item)}</li>
                    )) :
                   <li>No responsibilities available</li>
                  }
                </ul>
              </div>

              <div className="mt-6">
                <h2 className="text-lg font-semibold mb-3">Qualifications:</h2>
                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                  {Array.isArray(generatedContent?.qualifications) ? 
                    generatedContent.qualifications.map((item, index) => (
                      <li key={index}>{typeof item === 'string' ? item : JSON.stringify(item)}</li>
                    )) :
                   Array.isArray(jobData?.jobDescription?.generatedQualifications) ?
                    jobData.jobDescription.generatedQualifications.map((item, index) => (
                      <li key={index}>{typeof item === 'string' ? item : JSON.stringify(item)}</li>
                    )) :
                   <li>No qualifications available</li>
                  }
                </ul>
              </div>

              <div className="mt-6">
                <h2 className="text-lg font-semibold mb-3">Requirements:</h2>
                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                  {Array.isArray(generatedContent?.requirements) ? 
                    generatedContent.requirements.map((item, index) => (
                      <li key={index}>{typeof item === 'string' ? item : JSON.stringify(item)}</li>
                    )) :
                   Array.isArray(jobData?.jobDescription?.requirements) ?
                    jobData.jobDescription.requirements.map((item, index) => (
                      <li key={index}>{typeof item === 'string' ? item : JSON.stringify(item)}</li>
                    )) :
                   <li>No requirements available</li>
                  }
                </ul>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <PromptInput
                value={inputContent}
                onChange={setInputContent}
                onSubmit={handleGenerateContent}
                onSave={() => handleSaveContent(true)}
                loading={isGenerating}
                disabled={isSaving}
                placeholder="Enter content to generate new description..."
                showSaveButton={true}
                saveButtonText={isSaving ? "Saving..." : "Save & Continue"}
              />
              
             
            </div>

          </div>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      {renderJobDescription()}
    </>
  );
};

export default JobDescription;